const DATEFORMAT = {
  // Year only
  year: 'YYYY',

  // Month only
  onlyMonth: 'MMMM',
  onlyMMM: 'MMM',
  onlySingleMonth: 'M',

  // Month + Year
  yearMonth: 'YYYY-MM',
  monthYear: 'MMMM-YYYY',
  monthYearWithoutDash: 'MMMM YYYY',
  monthYearShort: 'MMM-YYYY',
  monthYearWithSlash: 'MM/YYYY',
  onlyMMMYYYY: 'MMM-YYYY',

  // Day + Month
  onlyDayMonth: 'DD MMM',

  // Date only (day + month + year)
  dayMonthYear: 'DD-MMM-YYYY',
  yearMonthDay: 'YYYY-MM-DD',
  dayMonthYearWithSlash: 'DD/MM/YY',
  dayMonthYearWithoutDash: 'DD MMM YYYY',
  dayMonthYearWithDash: 'DD-MM-YYYY',
  yearMonthDayWithoutDash: 'YYYY MMM DD',
  dayMonthYearWithNumber: 'DD-MMM-YY',
  dayMonthYearWithSingle: 'DD MMM YY',
  onlyDayMonthYearWithSlash: 'DD/MMM/YYYY',

  // Date with weekday
  onlyddDDMMMYY: 'ddd, DD MMM YY',
  onlyddDDMMMYYYY: 'ddd, DD MMM YYYY',
  onlyddDDMMMYYWithDash: 'ddd, DD-MMM-YYYY',
  dayDateMonthYearWithHoursMinutesSecondsMeridiem: 'ddd DD-MMM-YY HH:mm:ss A',

  // Date + time
  dayMonthDayWithHoursMinutesSecondsMeridiem: 'DD MMM YYYY hh:mm:ss A',
  dayMonthDayWithHoursMinutesSeconds: 'DD MMM YYYY HH:mm:ss',
  dayMonthYearTwelveHoursTimeFormat: 'DD MMM YYYY, HH:mm:ss A',
  onlyDDMMYYYHourMinutes: 'DD/MM/YYYY HH:mm',

  // ISO / timezone formats
  yearMonthDayWithTimezoneHoursMinutesSeconds: 'YYYY-MM-DDTHH:mm:ss',
  yearMonthDayWithZuluTime: 'YYYY-MM-DDTHH:mm:ss[Z]',
  onlyYearMonthDayTFormat: 'YYYY-MM-DD[T]00:00:00',
  onlyTimezoneYYYYMMDDD: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
};

export default DATEFORMAT;
